import { createReducer, on } from '@ngrx/store';

import NotificationActions from './actions';
import { NotificationState } from './feature';

export const initialNotificationState = (): NotificationState => ({
  notifications: undefined,
});

const NotificationReducer = createReducer(
  initialNotificationState(),
  on(NotificationActions.notificationsLoaded, (state, { notifications }) => ({
    ...state,
    notifications,
  })),
);

export default NotificationReducer;
